module.exports = require('./helpers/bundle-url').getBundleURL('01RMl') + "caiting-min.64c69471.jpeg";